import React from 'react'
import './Aboutus.css';

import LoginBg from '../../assets/images/LoginBg.jpg';
import Aboutuspage1 from '../../assets/images/Aboutuspage1.jpg';
import { Link } from 'react-router-dom';

const Aboutus = () => {

  return (
    <>
      <section className='AllpageheaderSection'>
        <div className='AllpageheaderSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <h6><Link to='/'><i className='fas fa-home'></i> Home</Link> <span className='PageHead'>ABOUT US</span></h6>
            </div>
          </div>
        </div>
      </section>
      <section className='AboutusPageSection'>
        <div className='AboutusPageSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 col-sm-7 col-xs-12'>
              <h2>ABOUT US</h2>
              <h3>Omnibus Industrial Development Corporation of Daman & Diu and Dadra & Nagar Haveli Limited, (OIDC Ltd).</h3>
              <p> A Government Undertaking was incorporated on 27th March 1992 under the Company’s Act 1956. OIDC Ltd has emerged as a truly Omnibus Corporation performing multifarious functions. The Corporation has the mandate to promote industrial investment, technological upgradation, occupational training, and skill development, as well as expand export-oriented industries within its jurisdictional area.
                The main activities performed by OIDC Ltd in the UT of Dadra and Nagar Haveli and Daman & Diu are:
                <ul>
                  <li>Development of Industrial Estates.</li>
                  <li>Supply of Quality Liquor.</li>
                  <li>Housing for EWS.</li>
                  <li>Infrastructure Development.</li>
                  <li>Scrap Disposal Management (Sugamta).</li>
                </ul>

                In a span of almost 32 years from its constitution, OIDC has emerged as a truly Omnibus Corporation carrying out multifarious activities of Development, Maintaining Industrial Estates, accelerating the economic development of the UT in the spheres including Industrial, Tourism, Liquor, Housing, Infrastructure development and other Allied Activities.

                At present, OIDC has an authorized share capital of Rs. 50 crore and paid up share capital of Rs. 26.06 crore. All the shares are in the name of President of India. The Corporation is headquartered in the city of Daman.

                During the financial year 2023 - 2024, Profit before Tax is Rs. 65,12,62,346/- and after tax is Rs. 48,24,51,742/- An amount of Rs. 99,74,68,803/- is contributed as Excise Duty and Rs. 21,58,87,234/- as Import Duty and Rs. 1,45,06,94,902/- towards VAT as per audited annual accounts.

              </p>
            </div>

            <div className='col-md-5 col-sm-5 col-xs-12'>
              <div className='Aboutuspageimg'>
                <img src={Aboutuspage1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Aboutus